/**
 * Booking utility helpers shared by step components.
 * Pure functions — no React imports.
 */

export const SVC_KEYS = ["exterior", "interior", "complete"];
